import { Flex } from "antd";
import "./CardCTA.scss";

type CardCTAProps = {
  icon?: React.ReactNode;
  label?: string;
  title: string;
  subtitle?: string;
  description: string;
  mainImageSrc?: string;
  tag?: React.ReactNode;
  actions?: React.ReactNode;
};

const CardCTA: React.FC<CardCTAProps> = (props) => {
  const {
    icon,
    label,
    title,
    subtitle,
    description,
    mainImageSrc,
    tag,
    actions,
  } = props;
  return (
    <Flex className="card-cta">
      <div className="label-ctas">
        <p>
          {icon}
          <span>{label}</span>
        </p>
      </div>
      <div className="cta">
        <div className="photo-cta">
          <img className="logo-image" src={mainImageSrc} alt="Anno Domini" />
        </div>
        <div className="content-cta">
          {tag}
          <p className="title-cta">{title}</p>
          {subtitle ? <p className="subtitle-cta">{subtitle}</p> : null}
          <p className="description-cta">{description}</p>
          <div
            className="container-btn-cta"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {actions}
          </div>
        </div>
      </div>
    </Flex>
  );
};

export default CardCTA;
